import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useClients } from '../hooks/useClients';
import { PageHeader } from '../components/Navigation';
import { getBackPath } from '../utils/navigation';
import '../ValidationHub.css';
import '../InvoiceDetail.css';
import '../Clients.css';
import ConfirmDialog from '../components/ConfirmDialog';

export default function ClientsPage() {
  const [q, setQ] = useState('');
  const [showPlaceholders, setShowPlaceholders] = useState(undefined);
  const [page, setPage] = useState(1);
  const [reloadKey, setReloadKey] = useState(0);
  const { data, status, error } = useClients({ q, placeholder: showPlaceholders, page, pageSize: 20, sort: 'nume.asc', reloadKey });
  const navigate = useNavigate();
  const location = useLocation();
  const backPath = getBackPath(location, '/validation-hub');

  const breadcrumbs = [
    { label: 'Validare', to: '/validation-hub' },
    { label: 'Emitenți', to: null }
  ];

  const onRowClick = (id) => navigate(`/clients/${id}`);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [toDelete, setToDelete] = useState(null); // { id, name }

  function askDelete(e, id, name) {
    e.stopPropagation();
    setToDelete({ id, name });
    setConfirmOpen(true);
  }

  async function performDelete() {
    if (!toDelete) return;
    try {
      const res = await (await import('../utils/api')).apiFetch(`/api/clients/${toDelete.id}`, { method: 'DELETE' });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.msg || 'Eroare la ștergere.');
      }
      setConfirmOpen(false);
      setToDelete(null);
      setReloadKey((k) => k + 1);
    } catch (e2) {
      setConfirmOpen(false);
      setToDelete(null);
      alert(e2.message);
    }
  }

  return (
    <div className="clients-page">
      <PageHeader
        backTo={backPath}
        backLabel="Înapoi la Validare"
        title="Emitenți"
        subtitle="Gestionați emitenții și activitatea lor"
        breadcrumbs={breadcrumbs}
        actions={
          <Link to="/clients/new" className="review-btn">Adaugă emitent</Link>
        }
      />

      <main className="validation-main">
        <div className="section-card">
          <div className="section-header" style={{ alignItems: 'center' }}>
            <div>
              <h2 className="section-title">Listă Emitenți</h2>
              <p className="section-subtitle">Căutați după nume, CUI sau email</p>
            </div>
          </div>
          <div className="section-content">
            <div className="clients-filters" style={{ marginBottom: '0.5rem' }}>
              <input
                type="text"
                className="clients-input"
                placeholder="Căutare nume/CUI/email"
                value={q}
                onChange={(e) => { setQ(e.target.value); setPage(1); }}
                style={{ minWidth: 280 }}
              />
              <select
                className="clients-select"
                value={showPlaceholders === undefined ? '' : showPlaceholders ? '1' : '0'}
                onChange={(e) => {
                  const v = e.target.value;
                  setShowPlaceholders(v === '' ? undefined : v === '1');
                  setPage(1);
                }}
              >
                <option value="">Toți</option>
                <option value="0">Doar complete</option>
                <option value="1">Doar necomplet</option>
              </select>
            </div>

            {status === 'loading' && <div>Se încarcă...</div>}
            {status === 'error' && <div className="error-message" style={{ color: '#b91c1c' }}>{error}</div>}

            {status === 'success' && (
              <>
                {/* --- THIS IS THE FIX --- */}
                <div className="lines-table-container">
                  <table className="lines-table">
                    <thead className="lines-table-head">
                      <tr>
                        <th>Nume</th>
                        <th>CUI</th>
                        <th>Email</th>
                        <th className="text-right">Facturi</th>
                        <th>Tip</th>
                        <th>Acțiuni</th>
                      </tr>
                    </thead>
                    <tbody className="lines-table-body">
                      {data.items.map((c) => (
                        <tr key={c.id} className="table-row clients-table-row" onClick={() => onRowClick(c.id)}>
                          <td>{c.nume || '—'}</td>
                          <td>{c.cui || '—'}</td>
                          <td>{c.email || '—'}</td>
                          <td className="lines-table-number">{c.invoices_count}</td>
                          <td>
                            {c.is_placeholder ? (
                              <span className="clients-badge-placeholder">Necomplet</span>
                            ) : (
                              'Complet'
                            )}
                          </td>
                          <td onClick={(e) => e.stopPropagation()}>
                            <button className="review-btn" onClick={(e) => askDelete(e, c.id, c.nume)}>
                              Șterge
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* --- END OF FIX --- */}

                <div className="pagination">
                  <div>
                    Pagina {data.page} din {Math.max(1, Math.ceil(data.total / data.page_size))}
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button className="review-btn" disabled={page <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>Înapoi</button>
                    <button className="review-btn" disabled={data.page * data.page_size >= data.total} onClick={() => setPage((p) => p + 1)}>Înainte</button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </main>
      <ConfirmDialog
        open={confirmOpen}
        title="Ștergere Emitent"
        message={`Ștergeți emitentul "${toDelete?.name || 'fără nume'}"? Această acțiune este ireversibilă.`}
        confirmText="Șterge"
        cancelText="Anulează"
        onConfirm={performDelete}
        onCancel={() => { setConfirmOpen(false); setToDelete(null); }}
      />
    </div>
  );
}